import React, { useState, useCallback } from 'react';
import { Navigate } from 'react-router-dom';


const DebtCollectionDashboard = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const debtors = [
    { id: 1, name: 'Paras Mistry', status: 'Overdue', amount: '£3000', dueDate: '01/02/24', action: 'Contact law firm' },
    { id: 2, name: 'Nathan James', status: 'Sent', amount: '£2000', dueDate: '01/02/24', action: '-' },
    { id: 3, name: 'Hannibal Higgins', status: 'Settled', amount: '-', dueDate: '20/12/23', action: '-' },
    { id: 4, name: 'Baanji', status: 'Settled', amount: '-', dueDate: '19/12/23', action: '-' },
    { id: 5, name: 'Megan Gibson', status: 'Settled', amount: '-', dueDate: '19/12/23', action: '-' },
    { id: 6, name: 'Ervin Puksts', status: 'Settled', amount: '-', dueDate: '18/12/23', action: '-' },
    { id: 7, name: 'Laura Blake', status: 'Sent', amount: '£1000', dueDate: '15/12/23', action: '-' },
    { id: 8, name: 'Diane Elgar', status: 'Pending', amount: '£55,000', dueDate: '13/12/23', action: 'Contact law firm' },
    { id: 9, name: 'Elisa Gashi', status: 'Overdue', amount: '£3000', dueDate: '11/12/23', action: 'Contact law firm' },
    { id: 10, name: 'Julie Wyse', status: 'Settled', amount: '-', dueDate: '10/12/23', action: '-' },
  ];

  const filteredDebtors = activeTab === 'all' 
    ? debtors 
    : debtors.filter(debtor => debtor.status.toLowerCase() === activeTab.toLowerCase());

  const searchedDebtors = filteredDebtors.filter(debtor => 
    debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
    debtor.amount.toLowerCase().includes(searchQuery.toLowerCase()) ||
    debtor.dueDate.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    'Overdue': 'bg-red-100 text-red-500 border-red-200',
    'Sent': 'bg-blue-100 text-blue-500 border-blue-200',
    'Pending': 'bg-yellow-100 text-yellow-600 border-yellow-200',
    'Settled': 'bg-green-100 text-green-500 border-green-200'
  };

  const statusIconMap = {
    'Overdue': '•',
    'Sent': '•',
    'Pending': '•',
    'Settled': '•'
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center space-x-6">
            <div className="flex items-center">
              <div className="text-teal-500 mr-2">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="5" height="18" rx="1" fill="#0F766E" />
                  <rect x="10" y="8" width="5" height="13" rx="1" fill="#0F766E" opacity="0.7" />
                  <rect x="17" y="5" width="5" height="16" rx="1" fill="#0F766E" opacity="0.4" />
                </svg>
              </div>
              <div className="font-bold text-gray-800 text-lg">DEBT CO-PILOT</div>
            </div>
            
            <div className="hidden md:flex space-x-4">
              <div className="relative group">
                <button className="px-3 py-2 rounded-md text-gray-700 bg-white border border-gray-200 font-medium flex items-center">
                  Debt collection
                  <svg className="ml-1 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
              <button className="px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 font-medium">
                Outcomes & costs
              </button>
              <button className="px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 font-medium">
                AI indicators
              </button>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <button className="p-2 rounded-full text-gray-500 hover:bg-gray-100">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
            <button className="p-2 rounded-full text-gray-500 hover:bg-gray-100">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>
            <button className="p-2 rounded-full text-gray-500 hover:bg-gray-100">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center text-sm text-gray-600">
          <a href="#" className="hover:text-gray-800">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          </a>
          <span className="mx-2">/</span>
          <span>Late Payment Demand (LPD)</span>
        </div>
      </div>

      {/* Page Title */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Late payment demand (LPD)</h1>
            <p className="text-gray-600 mt-1">All information regarding your LPD.</p>
          </div>
          <button className="bg-white hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 border border-gray-300 rounded-lg shadow-sm flex items-center">
            <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            New LPD
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Total LPDs */}
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 relative">
            <div className="absolute top-6 right-6">
              <button className="text-gray-400 hover:text-gray-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>
            </div>
            <div className="p-2 bg-gray-100 rounded-lg inline-flex items-center justify-center w-10 h-10 mb-4">
              <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-sm font-medium text-gray-600 mb-2">Total LPD's generated</h2>
            <p className="text-3xl font-bold text-gray-800">65</p>
          </div>

          {/* Settled LPDs */}
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 relative">
            <div className="absolute top-6 right-6">
              <button className="text-gray-400 hover:text-gray-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>
            </div>
            <div className="p-2 bg-gray-100 rounded-lg inline-flex items-center justify-center w-10 h-10 mb-4">
              <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-sm font-medium text-gray-600 mb-2">Settled LPD's</h2>
            <p className="text-3xl font-bold text-gray-800">50</p>
          </div>

          {/* Pending LPDs */}
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 relative">
            <div className="absolute top-6 right-6">
              <button className="text-gray-400 hover:text-gray-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>
            </div>
            <div className="p-2 bg-gray-100 rounded-lg inline-flex items-center justify-center w-10 h-10 mb-4">
              <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h2 className="text-sm font-medium text-gray-600 mb-2">Pending LPD's</h2>
            <p className="text-3xl font-bold text-gray-800">15</p>
          </div>
        </div>
      </div>

      {/* LPDs Table Section */}
      <div className="container mx-auto px-4 py-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          {/* Table Header */}
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex justify-between items-center flex-wrap gap-4">
              <div className="flex items-center">
                <h2 className="text-lg font-medium text-gray-800">Generated LPD's</h2>
                <span className="ml-3 px-2 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">10 entries</span>
              </div>
              <button className="flex items-center bg-white hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 border border-gray-300 rounded-lg shadow-sm">
                <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download
              </button>
            </div>
          </div>

          {/* Filter Bar */}
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex flex-wrap gap-3 items-center justify-between">
            <div className="flex flex-wrap gap-1">
              <button 
                onClick={() => setActiveTab('all')}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === 'all' 
                    ? 'bg-white shadow-sm border border-gray-200 text-gray-800' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                View all
              </button>
              <button 
                onClick={() => setActiveTab('sent')}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === 'sent' 
                    ? 'bg-white shadow-sm border border-gray-200 text-gray-800' 
                    : 'text-gray-600 hover:bg-gray-100'                                                                                        
                }`}
              >
                Sent
              </button>
              <button 
                onClick={() => setActiveTab('pending')}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === 'pending' 
                    ? 'bg-white shadow-sm border border-gray-200 text-gray-800' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Pending
              </button>
              <button 
                onClick={() => setActiveTab('overdue')}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === 'overdue' 
                    ? 'bg-white shadow-sm border border-gray-200 text-gray-800' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Overdue
              </button>
              <button 
                onClick={() => setActiveTab('settled')}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === 'settled' 
                    ? 'bg-white shadow-sm border border-gray-200 text-gray-800' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Settled
              </button>
            </div>
            
            <div className="flex flex-wrap gap-3 items-center">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search your LBA"
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full md:w-64"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <button className="flex items-center bg-white hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 border border-gray-300 rounded-lg shadow-sm">
                <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                Filter
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Debtor's name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Amount due
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Due date
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {searchedDebtors.map((debtor) => (
                  <tr key={debtor.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {debtor.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-3 py-1 text-xs font-medium rounded-full border ${statusColorMap[debtor.status]}`}>
                        <span className="mr-1">{statusIconMap[debtor.status]}</span> {debtor.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {debtor.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {debtor.dueDate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      {debtor.action === 'Contact law firm' ? (
                        <button className="text-blue-600 hover:text-blue-800 font-medium">
                          Contact law firm
                        </button>
                      ) : (
                        debtor.action
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="px-6 py-4 flex items-center justify-between border-t border-gray-200">
            <div className="flex-1 flex justify-between sm:hidden">
              <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Previous
              </button>
              <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Next
              </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  Page <span className="font-medium">1</span> of <span className="font-medium">10</span>
                </p>
              </div>
              <div>
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  <button className="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    Previous
                  </button>
                  <button className="relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    Next
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="container mx-auto px-4 py-6 mt-auto">
        <div className="text-center text-xs text-gray-500">
          Copyright © Think-AI 2023
        </div>
      </footer>
    </div>
  );
};

export default DebtCollectionDashboard;